import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { CircuitMapService } from './circuit-map.service';
import { MetricsService } from '../metrics/shared/metrics.service';
import { EChartsOption } from 'echarts';
import * as echarts from 'echarts';
import { usaMap } from 'src/assets/usaMap';

@Component({
    selector: 'app-circuit-map',
    templateUrl: './circuit-map.component.html',
    styleUrls: ['./circuit-map.component.scss'],
    standalone: false
})
export class CircuitMapComponent implements OnInit {

  circuitsOption: EChartsOption;
  circuitsByStore = {};
  isLoading: Boolean;
  vendorCountsDict = {};
  speedCountsDict = {};
  speedCountsList = [];
  typeCountsDict = {};
  monthlyChargeCountsDict = {};
  fortinetAvailability = {};

  constructor(private circuitMapService: CircuitMapService, private metricsService: MetricsService) { }

  ngOnInit() {
    this.isLoading = true;
    Promise.all(
      [
        this.getAllCircuits(),
        this.getFortinetAvailability()

      ]
    ).then(() => {
        this.renderMap();
        this.renderMetrics();
        this.isLoading = false;
    }).catch((e) => {
      console.log('Promise.all REJECTED');
      console.log(e);
      this.isLoading = false;
    });

  };

  getFortinetAvailability() {
    const promise = new Promise((resolve) => {
      this.metricsService.getFortinetAvailabilityOrg().then(response => {
        response.toPromise().then(response => {
          try {
            this.fortinetAvailability = response["message"].pop();
            // console.log(this.fortinetAvailability);
          } catch (error) {
            console.log(error.message)
          } finally {
            resolve(true);
          }
        });
      });
    });  

    return promise;   
  }

  getAllCircuits() {
    const promise = new Promise((resolve) => {
      this.circuitMapService.getAllCircuits().then(response => {
        response.toPromise().then(response => {
          try {
            this.circuitsByStore = response["message"];
          } catch (error) {
            console.log(error.message)
          } finally {
            resolve(true);
          }
        });
      });
    });  

    return promise;
  }

  renderMetrics() {
    // Looping one metric at a time for readability--it's still O(N) but could be slightly faster with a different algo

    Object.keys(this.circuitsByStore).forEach(store => {
      this.circuitsByStore[store].forEach(circuit => {

        let vendor = circuit["vendor"] ? circuit["vendor"] : 'Unknown';

        if (!(vendor in this.vendorCountsDict)) {
          this.vendorCountsDict[vendor] = 1;
        } else {
          this.vendorCountsDict[vendor] += 1;
        }
      })
    })

    Object.keys(this.circuitsByStore).forEach(store => {
      this.circuitsByStore[store].forEach(circuit => {

        let type = circuit["type"] ? circuit["type"] : 'Unknown';

        if (!(type in this.typeCountsDict)) {
          this.typeCountsDict[type] = 1;
        } else {
          this.typeCountsDict[type] += 1;
        }
      })
    })
    
    Object.keys(this.circuitsByStore).forEach(store => {
      this.circuitsByStore[store].forEach(circuit => {

        // console.log("circuit: ", circuit)
        // Keys have to be strings
        let commit_rate_str = circuit["commit_rate"] ? circuit["commit_rate"].toString() : 'Unknown';

        // "countknownMrc" is needed because not every circuit has a defined MRC, so to find an average without skewing it down due to zeroes,
        // we keep a count of Known MRCs
        if (!(commit_rate_str in this.speedCountsDict)) {
          this.speedCountsDict[commit_rate_str] = {};
          this.speedCountsDict[commit_rate_str]["count"] = 1;
          this.speedCountsDict[commit_rate_str]["countKnownMrc"] = circuit["monthly_recurring_charge"] ? 1 : 0;
          this.speedCountsDict[commit_rate_str]["mrcTotal"] = circuit["monthly_recurring_charge"] ? parseFloat(circuit["monthly_recurring_charge"]) : 0;
        } else {
          this.speedCountsDict[commit_rate_str]["count"] += 1;
          this.speedCountsDict[commit_rate_str]["countKnownMrc"] += circuit["monthly_recurring_charge"] ? 1 : 0;
          this.speedCountsDict[commit_rate_str]["mrcTotal"] += circuit["monthly_recurring_charge"] ? parseFloat(circuit["monthly_recurring_charge"]) : 0;
        }

        this.speedCountsList = Object.entries(this.speedCountsDict).map(([key, value]) => {
          return {
            speed: key,
            ...(value as object)
          };
        });

      })
    })

    Object.keys(this.circuitsByStore).forEach(store => {
      this.circuitsByStore[store].forEach(circuit => {

        // Keys have to be strings
        let monthly_charge_str = circuit["monthly_recurring_charge"] ? circuit["monthly_recurring_charge"].toString() : 'Unknown';

        if (!(monthly_charge_str in this.monthlyChargeCountsDict)) {
          this.monthlyChargeCountsDict[monthly_charge_str] = 1;
        } else {
          this.monthlyChargeCountsDict[monthly_charge_str] += 1;
        }
      })
    })


    // console.log(this.vendorCountsDict);
    // console.log(this.typeCountsDict);
    // console.log(this.speedCountsDict);
    // console.log(this.monthlyChargeCountsDict);


  }

  renderMap() {

    let series = [];

    Object.keys(this.circuitsByStore).forEach(store => {
      let format = `<strong>${this.circuitsByStore[store][0]["store_name"]}</strong> ${store}<br />`;
      this.circuitsByStore[store].forEach(circuit => {

        format += `
                  <br />
                  Circuit: ${circuit["cid"]}<br />
                  Commit Rate: ${circuit["commit_rate"]/1000}mb<br />
                  Vendor: ${circuit["vendor"]}<br />
                  Type: ${circuit["type"]}<br />
                  Monthly Charge: ${circuit["monthly_recurring_charge"] ? '$' + circuit["monthly_recurring_charge"] : 'Unknown'}<br />
                  `
      })
      series.push(
        {
          // Super hacky way to force echarts to give you tooltips on circular markers on a map.
          // Couldn't find another way to do this, but it works perfectly fine.
          type: 'pie',
          coordinateSystem: 'geo',
          tooltip: {
            show: true,
            formatter: format
            // formatter: "{b}"
          },
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          animationDuration: 0,
          radius: 3,
          center: [this.circuitsByStore[store][0]["longitude"], this.circuitsByStore[store][0]["latitude"]],
          itemStyle: {
            color: "#FF0000"
          },
          // Dummy data for the "pie" chart (just a circle)
          data: [{value: 1, name: "This doesn't matter"}]
        }
      )
    });

    echarts.registerMap('USA', usaMap, 
    {
      Alaska: {
        left: -141,
        top: 55,
        width: 15
      },
      Hawaii: {
        left: -160,
        top: 19,
        width: 5
      },
      'Puerto Rico': {
        left: -67,
        top: 18,
        width: 2
      }
    });
    
    this.circuitsOption = {
      geo: {
        map: 'USA',
        roam: true,
        itemStyle: {
          areaColor: '#e7e8ea'
        },
        zoom: 1,
        scaleLimit: {
          min: 1,
          max: 30
        }
      },
      tooltip: {
        show: false
      },
      legend: {
        show: false
      },
      emphasis: {
        disabled: true
      },
      series: series
      }
  };

}
